var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("van-icon", {
          staticClass: "header-return",
          attrs: { name: "arrow-left", size: "25", color: "#ffffff" },
          on: {
            click: function($event) {
              return _vm.onClickHeaderReturn()
            }
          }
        }),
        _vm._v("\n    History\n  ")
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "van-pull-refresh",
          {
            attrs: {
              "pulling-text": "Pull down to refresh",
              "loading-text": "Loading...",
              "success-text": "Refresh success",
              "loosing-text": "Release to refresh"
            },
            on: { refresh: _vm.onRefresh },
            model: {
              value: _vm.refreshing,
              callback: function($$v) {
                _vm.refreshing = $$v
              },
              expression: "refreshing"
            }
          },
          [
            _c(
              "van-list",
              {
                attrs: {
                  finished: _vm.finished,
                  "finished-text": "No more data",
                  "loading-text": "Loading more...",
                  error: _vm.error,
                  "error-text": "Load fail! Click reload"
                },
                on: {
                  "update:error": function($event) {
                    _vm.error = $event
                  },
                  load: _vm.onLoad
                },
                model: {
                  value: _vm.loading,
                  callback: function($$v) {
                    _vm.loading = $$v
                  },
                  expression: "loading"
                }
              },
              _vm._l(_vm.historyList, function(item, index) {
                return _c("div", { key: index, staticClass: "history-item" }, [
                  _c("div", { staticClass: "history-header" }, [
                    _c("div", { staticClass: "header-title" }, [
                      _vm._v(_vm._s(item.modeName))
                    ]),
                    _c("div", { staticClass: "header-time" }, [
                      _vm._v(_vm._s(item.createTime))
                    ])
                  ]),
                  _c("div", { staticClass: "item-split" }),
                  _c(
                    "div",
                    { staticClass: "history-content" },
                    [
                      _c("div", { staticClass: "history-row" }, [
                        _c("div", { staticClass: "history-left-title" }, [
                          _vm._v("NFC Settings")
                        ]),
                        _c("div", { staticClass: "history-right-value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.isSupportNfc ? `ON` : `OFF`) +
                              "\n              "
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "history-row" }, [
                        _c("div", { staticClass: "history-left-title" }, [
                          _vm._v("Preheat")
                        ]),
                        _c("div", { staticClass: "history-right-value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                item.isSupportPreheat
                                  ? `${(item.preheatVoltage / 1000).toFixed(
                                      1
                                    )}v, ${(item.preheatTime / 1000).toFixed(
                                      1
                                    )}s`
                                  : `OFF`
                              ) +
                              "\n              "
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "history-row" }, [
                        _c("div", { staticClass: "history-left-title" }, [
                          _vm._v("Voltage Curve")
                        ]),
                        _c("div", { staticClass: "history-right-value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                item.diyVoltage
                                  .map(item => `${(item / 1000).toFixed(1)}v`)
                                  .join(", ")
                              ) +
                              "\n              "
                          )
                        ])
                      ]),
                      item.position > 0
                        ? _c("div", { staticClass: "history-row" }, [
                            _c("div", { staticClass: "history-left-title" }, [
                              _vm._v("Curve Level")
                            ]),
                            _c("div", { staticClass: "history-right-value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.position) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      item.outputInterval
                        ? _c("div", { staticClass: "history-row" }, [
                            _c("div", { staticClass: "history-left-title" }, [
                              _vm._v("Output Duration")
                            ]),
                            _c("div", { staticClass: "history-right-value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.outputInterval) +
                                  "\n              "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _c(
                        "van-button",
                        {
                          staticClass: "history-button-apply",
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.onClickApply(item)
                            }
                          }
                        },
                        [_vm._v("Apply To homepage")]
                      )
                    ],
                    1
                  )
                ])
              }),
              0
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "footer" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }